import { render } from "./OpenGymBenefits.vue?vue&type=template&id=16f3aa18"
import script from "./OpenGymBenefits.vue?vue&type=script&lang=js"
export * from "./OpenGymBenefits.vue?vue&type=script&lang=js"

import "./OpenGymBenefits.vue?vue&type=style&index=0&id=16f3aa18&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__